import { render, staticRenderFns } from "./IbanInputField.vue?vue&type=template&id=26644db6&scoped=true"
import script from "./IbanInputField.vue?vue&type=script&lang=ts"
export * from "./IbanInputField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26644db6",
  null
  
)

export default component.exports